import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScalpCardCopy } from '@services/concern-detections-service';

@Component({
  selector: 'app-hair-photo-not-detected-card',
  templateUrl: './hair-photo-not-detected-card.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class HairPhotoNotDetectedCardComponent {
  @Input() copy: ScalpCardCopy | undefined;
  @Input() isHairFrontNotVisible: boolean = false;
  @Input() titleSizeClass: string = 'tw-text-500';
  @Input() descriptionSizeClass: string = 'tw-text-200';
}
